import { render, staticRenderFns } from "./LoaderPartial.vue?vue&type=template&id=cd40232a"
import script from "../../js/components/partials/Loader.js?vue&type=script&lang=js&external"
export * from "../../js/components/partials/Loader.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports